var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 144,
  height: 144,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#image_clock_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 23.667A2.667 2.667 0 0 1 12.667 21h104.666A2.667 2.667 0 0 1 120 23.667V31H10v-7.333Z",
  fill: "#8A8A8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.5 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM110.5 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM115.5 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM10 31h110v75.333a2.667 2.667 0 0 1-2.667 2.667H12.667A2.667 2.667 0 0 1 10 106.333V31Z",
  fill: "#5E5E5E"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24 37.667A2.667 2.667 0 0 1 26.667 35h104.666A2.667 2.667 0 0 1 134 37.667V45H24v-7.333Z",
  fill: "#8A8A8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.5 42a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM124.5 42a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM129.5 42a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM24 45h110v75.333a2.667 2.667 0 0 1-2.667 2.667H26.667A2.667 2.667 0 0 1 24 120.333V45Z",
  fill: "#5E5E5E"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#424242",
  d: "M48 57h62v4H48zM48 67h62v4H48z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#image_clock_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 117,
  r: 20,
  fill: "#FABA2A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117 103v14.175L128.5 127",
  stroke: "#151515",
  strokeWidth: 4,
  strokeLinecap: "round"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "image_clock_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h144v144H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "image_clock_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(97 97)",
  d: "M0 0h40v40H0z"
})))));
export { SvgImageClock as ReactComponent };
export default "/18ca9161d2bd8cb380ca1acd5f359129.svg";